import React from 'react'
import { string } from 'prop-types'
import { Helmet } from 'react-helmet'

const MetaTags = ({ title, description }) => (
  <Helmet>
    {/* Global */}
    <meta charSet="utf-8" />
    <meta httpEquiv="x-ua-compatible" content="ie=edge" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" key="viewport" />

    {/* Title + description */}
    <title>{title || 'Vape - shop online - Vuse Canada'}</title>
    <meta
      name="description"
      content={
        description ||
        'Vape - shop online, in Canada. Vuse offers you the very best vape kits to kick start your vaping experience and competitive prices. Take a look here today.'
      }
    />

    {/* Facebook */}
    <meta property="og:title" content={title || 'Vape - shop online - Vuse Canada'} />
    <meta
      property="og:description"
      content={
        description ||
        'Vape - shop online, in Canada. Vuse offers you the very best vape kits to kick start your vaping experience and competitive prices. Take a look here today.'
      }
    />
    <meta property="og:type" content="website" key="og:type" />
    <meta property="og:image" content="https://www.vuse.com/ca/en/images/share-image.png" key="og:image" />
    <meta property="og:url" content="https://www.vuse.com/ca/en/" key="og:url" />

    {/* Twitter */}
    <meta name="twitter:card" content="summary_large_image" key="twitter:card" />
    <meta name="twitter:creator" content="@govypeca" key="twitter:creator" />
    <meta name="twitter:title" content={title || 'Vape - shop online - Vuse Canada'} />
    <meta
      name="twitter:description"
      content={
        description ||
        'Vape - shop online, in Canada. Vuse offers you the very best vape kits to kick start your vaping experience and competitive prices. Take a look here today.'
      }
    />
    <meta name="twitter:image" content="https://www.vuse.com/ca/en/images/share-image.png" key="twitter:image" />
    <meta name="twitter:url" content="https://www.vuse.com/ca/en/images/share-image.png" key="twitter:url" />
  </Helmet>
)

MetaTags.propTypes = {
  title: string,
  description: string
}

export default MetaTags
